<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <div class="d-flex flex-column gap-3">
    <!-- Tipo: Monthly / One-Time (CVA) -->
    <lib-donation-type-toggle
  [plans]="plans"
  [disabledPlanIds]="disabledPlanIds"
  formControlName="donationType">
</lib-donation-type-toggle>
    <!-- Mensaje de validación -->
    <div class="text-danger small" *ngIf="form.get('donationType')?.invalid && form.get('donationType')?.touched">
      {{ donationTypeError }}
    </div>

    <!-- Monto sugerido + personalizado -->
    <div>
      <!-- El chip activo se pinta con selected -->
      <lib-amount-selector
        [selected]="form.get('unitAmount')?.value"
        (select)="onAmountSelect($event)">
      </lib-amount-selector>

      <p class="price-form__custom-label">{{ 'CAMPAIGN.CustomAmountPrompt' | translate }}</p>

      <div class="input-group mt-2">
        <span class="input-group-text">$</span>
        <input type="number" class="form-control" formControlName="unitAmount" />
        <span class="input-group-text">USD</span>
      </div>
    </div>

    <button type="submit" [disabled]="form.invalid || !!donationTypeError" class="btn btn-primary col-12 price-form__submit">
      <span class="price-form__submit-label-wrap">
        <span class="price-form__submit-label">{{ 'CAMPAIGN.Continue' | translate }}</span>
        <span class="price-form__submit-arrow" aria-hidden="true">→</span>
      </span>
      <span class="price-form__submit-burst" aria-hidden="true"></span>
    </button>
  </div>

  <!-- Campos ocultos que igual van al store -->
  <input formControlName="nickname" type="hidden" />
  <input formControlName="currency" type="hidden" />
</form>
